import React from "react";
import { Box, Text } from "@saleor/macaw-ui-next";

interface VendorAddressesProps {
  id: string;
  params: any;
}

const VendorAddressesView: React.FC<VendorAddressesProps> = ({ id }) => {
  return (
    <Box padding={6}>
      <Text>Vendor Addresses Page - ID: {id}</Text>
      <Text>This page is under development.</Text>
    </Box>
  );
};

export default VendorAddressesView;